import { Context } from '@nuxt/types';
import _camelCase from 'lodash.camelcase';
import _mapKeys from 'lodash.mapkeys';
import { getUserAgentInfo } from '~/utils';

export default async function(context: Context) {
  const { app, route, from, store } = context;
  const {
    loggedIn,
    id,
    walletExists,
    twoFaEnabled,
    emailVerified,
    goldMember,
  } = store.state.profile.user;

  app.$mixpanel.register({ loggedIn });

  // Only do this if coming from external site
  if (route.path === from.path) {
    if (loggedIn) {
      app.$mixpanel.identify(id);
    }
    // get referral context
    const utmVariables = JSON.parse(
      localStorage.getItem('utm-variables') || '{}',
    );
    const formattedUtmVariables = _mapKeys(
      utmVariables,
      (value: any, key: string) => {
        return _camelCase(key);
      },
    );
    const offer = localStorage.getItem('offer') || '';
    const r = localStorage.getItem('r') as string;
    const referredBy = r || (localStorage.getItem('referredBy') as string);

    const referralContext = {
      ...formattedUtmVariables,
      offer,
      referredBy,
    };

    // get user agent information
    const userAgentInfo = await getUserAgentInfo();
    store.commit('updateUserAgentInfo', userAgentInfo);

    app.$mixpanel.register({
      ...referralContext,
      ...userAgentInfo,
      walletExists,
      emailVerified,
      twoFaEnabled,
      goldMember,
    });
  }
}
